import {
  LanguageFieldsFragment,
  LanguageId,
} from 'lib-knowledge-management-common/graphql';
import { MarkOptional } from 'ts-essentials';

export type LanguageModel = MarkOptional<LanguageFieldsFragment, '__typename'>;

type GetLabelsForLanguageParams = {
  languageId: LanguageId;
  languages: LanguageModel[];
};
type LanguageLabels = Pick<
  LanguageFieldsFragment,
  'description' | 'nativeDescription'
>;

export function getLabelsForLanguage({
  languageId,
  languages,
}: GetLabelsForLanguageParams): LanguageLabels {
  const language = languages.find((lang) => {
    return lang.languageId === languageId;
  });

  if (language === undefined) {
    // Could not find a matching label for the languageId provided
    const placeholder = `Unknown lang: "${languageId}"`;
    return {
      description: placeholder,
      nativeDescription: placeholder,
    };
  }

  return {
    description: language.description,
    nativeDescription: language.nativeDescription,
  };
}
